import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel, FormControl
} from "@mui/material";
import moment from "moment";
// import { FormControl } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import {
// 	MuiPickersUtilsProvider,
// 	DatePicker
// } from "@mui/material/pickers";
import { Tooltip } from "antd";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
// import Tooltip from "@mui/material/Tooltip";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbDownAltRounded"
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { getKycReportList } from "../../redux/actions/getKycReportListAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import { getWalletTransactionList } from "../../redux/actions/getWalletTransactionListAction";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactToExcel from "react-html-table-to-excel";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

import {
	getKycApproveRejects,
	resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import SearchIcon from "@mui/icons-material/Search";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminKycReport() {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);

	const [selectedToDate, setSelectedToDate] = useState(new Date());

	const navigate = useHistory();

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getKycReportListStatus, setGetKycReportListStatus] = useState(false);
	const [getKycReportListArray, setGetKycReportListArray] = useState([]);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const [getWalletTransactionListArray, setGetWalletTransactionListArray] =
		useState([]);

	const [getWalletTransactionListStatus, setGetWalletTransactionListStatus] =
		useState(false);

	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);

	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		verificationId: "",
		walletOwnerId: "",
		parentId: "",
		verificationStatus: "",
		action: "",
		role: ""
	});

	const {
		verificationId,
		walletOwnerId,
		parentId,
		verificationStatus,
		action,
		role
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getKycReportListRes = useSelector(
		({ getKycReportList }) => getKycReportList
	);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getWalletTransactionListRes = useSelector(
		({ getWalletTransactionList }) => getWalletTransactionList
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getRoleListStatusFunc = () => {
		if (getRoleStatus) {
			if (getRoleListRes.data.status == "success") {
				setGetRoleResArray([].concat(getRoleListRes.data.roleList));
			}
			if (getRoleListRes.data.status == "failed") {
				setGetRoleResArray(getRoleListRes.data);
				if (
					getRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getRoleListStatusFunc();
	}, [getRoleListRes.data.status]);

	const getRoleListReq = () => {
		setGetRoleStatus(true);
		dispatch(
			getRoleList(
				{
					ownerMasterRequestVO: {
						adminId: val.adminIDS,

						// adminId: 2,
						roleName: ""
					}
				},
				authToken
			)
		);
	};

	useEffect(() => {
		getRoleListReq();
	}, []);

	const sendVerificationId = (vId, cId) => {
		// setPageToggle(true);
		navigate.push({
			pathname: `/index/KycDetails`,
			state: { param1: `${vId}`, param2: `${cId}` }
		});
	};
	const getKycReportListReq = () => {
		setGetKycReportListStatus(true);
		setIsLoading(true);
		let req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: walletOwnerId == "Select Owner Id" ? "" : walletOwnerId.split("-")[0],
				verificationId: verificationId,
				customerId: parentId,
				fdtStamp: moment(selectedDate).format("DD/MM/YYYY"),
				tdtStamp: moment(selectedToDate).format("DD/MM/YYYY"),
				verificationStatus:
					verificationStatus == "All" ? "" : verificationStatus,
				action: action,
				role: role
			}
		};
		dispatch(getKycReportList(req, authToken));
	};

	useEffect(() => {
		getKycReportListFunc();
	}, [getKycReportListRes.data.status]);

	const getKycReportListFunc = () => {
		if (getKycReportListStatus) {
			if (getKycReportListRes.data.status == "success") {
				setGetKycReportListArray(
					[].concat(getKycReportListRes.data.customerMasterDetailsRequestVOList)
				);
				setIsLoading(false);
			}
			if (getKycReportListRes.data.status == "failed") {
				setGetKycReportListArray(getKycReportListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKycReportListRes.data.description
				);
				if (
					getKycReportListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycReportListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycReportListRes.data.status == "Not Found") {
				setGetKycReportListArray(getKycReportListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getKycReportListRes.data.status
				);
			}
		}
	};

	const getTransactionTypeList = () => {
		if (getTransactionTypeListRes.data.status == "success") {
			setGetTransactionTypeListResArray(
				getTransactionTypeListRes.data.transactionType
			);
		}
	};

	useEffect(() => {
		getTransactionTypeList();
	}, []);

	const getTransactionTypeListReqApi = () => {
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: "1"
			}
		};

		return dispatch(
			getTransactionTypeListDetails(getTransactionTypeListReq, authToken)
		);
	};

	useEffect(() => {
		getTransactionTypeListReqApi();
	}, []);

	// const getWalletTransactionListReq = () => {
	// 	setGetWalletTransactionListStatus(true);
	// 	const getTransactionTypeListReqIs = {
	// 		loginDetails: {
	// 			walletOwnerId: "1"
	// 		},
	// 		walletTransactionMasterDetailsRequestVO: {
	// 			currency: currency,
	// 			fromDate: moment(selectedDate).format("DD/MM/YYYY"),
	// 			toDate: moment(selectedToDate).format("DD/MM/YYYY"),
	// 			transactionId: transactionId,
	// 			isFee: isFee,
	// 			walletCustomerId: fromCustomerId
	// 		}
	// 	};

	// 	return dispatch(
	// 		getWalletTransactionList(getTransactionTypeListReqIs, authToken)
	// 	);
	// };

	useEffect(() => {
		if (getWalletTransactionListStatus) {
			getWalletTransactionListFun();
		}
	}, [getWalletTransactionListRes.data.status]);

	const getWalletTransactionListFun = () => {
		if (getWalletTransactionListRes.data.status == "success") {
			setGetWalletTransactionListArray(
				[].concat(getWalletTransactionListRes.data.transactionList)
			);
		}
		if (getWalletTransactionListRes.data.status == "failed") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}

		if (getWalletTransactionListRes.data.status == "Failed") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}

		if (getWalletTransactionListRes.data.status == "NOT FOUND") {
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	// const columns = [
	// 	{ title: "Name", field: "balance" },
	// 	{ title: "Email", field: "creditAmount" },
	// 	{ title: "Year", field: "currency" },
	// 	{ title: "Fee", field: "debitAmount" },
	// 	{ title: "Name", field: "fromCustomerId" },
	// 	{ title: "Email", field: "fromCustomerName" },
	// 	{ title: "Year", field: "fromDate" },
	// 	{ title: "Fee", field: "fromWalletName" },
	// 	{ title: "Name", field: "isFee" },
	// 	{ title: "Email", field: "manualCode" },
	// 	{ title: "Year", field: "orderDescription" },
	// 	{ title: "Fee", field: "remark" },
	// 	{ title: "Name", field: "toCustomerContact" },
	// 	{ title: "Email", field: "toCustomerName" },
	// 	{ title: "Year", field: "currency" },
	// 	{ title: "Fee", field: "debitAmount" },
	// 	{ title: "Name", field: "fromCustomerId" },
	// 	{ title: "Email", field: "fromCustomerName" },
	// 	{ title: "Year", field: "fromDate" },
	// 	{ title: "Fee", field: "fromWalletName" },
	// 	{ title: "Name", field: "isFee" },
	// 	{ title: "Email", field: "manualCode" },
	// 	{ title: "Year", field: "orderDescription" },
	// 	{ title: "Fee", field: "remark" }
	// ];

	const exportToExcel = () => {
		if (getWalletTransactionListArray.length !== undefined) {
			var wb = XLSX.utils.book_new();
			var ws = XLSX.utils.json_to_sheet(getWalletTransactionListArray);
			XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
			XLSX.writeFile(wb, "WalletTransaction.xlsx");
		}
	};

	const exportToPdf = () => {
		const doc = new jsPDF();
		doc.autoTable({
			html: "#walletTransation",
			styles: {
				halign: "center",
				valign: "middle",
				cellWidth: "auto",
				fontSize: 7
			}
		});
		doc.save("WalletTransaction.pdf");
	};

	const handleAcceptOrRejectReq = (
		verificationId,
		customerId,
		userRole,
		personId,
		fileName,
		action,
		recommendationtype
	) => {
		const acceptOrRejectReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId
			},
			actionCustomerMasterRequestVO: {
				recommendation: recommendationtype,
				action: action,
				customerId: customerId,
				personId: personId,
				regFraudId: verificationId
				// fileName: fileName
				//role: userRole,
			}
		};
		return dispatch(getKycApproveRejects(acceptOrRejectReq, authToken));
	};

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			console.log("Lcs", getWalletOwnerIdRes)
			if (getWalletOwnerIdRes.data.status == "success") {
				console.log("Lcssss", getWalletOwnerIdRes)

				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getWalletOwnerIdRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"));
				}
			}
			if (getWalletOwnerIdRes.data.status == "NOT FOUND") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						adminId: val.adminIDS

						// adminId: "2"
					}
				},
				authToken
			)
		);
	};
	useEffect(() => {
		// if (regenerateTokenRes.data.status == "success") {

		getWalletOwnerIdAndNameListReq();
		// }
	}, []);
	useEffect(() => {
		console.log("made get req");
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes]);

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<FormControl fullWidth>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
									/>
								</LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<FormControl fullWidth>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
									/>
								</LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								variant="standard"
								type="text"
								label="Verification ID"
								fullWidth={true}
								name="verificationId"
								value={verificationId}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid>
						{/* <Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								required
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Owner ID"
								fullWidth={true}
								name="walletOwnerId"
								value={walletOwnerId}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid> */}
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								required
								margin="dense"
								variant="standard"

								select
								style={{ marginTop: "3px" }}

								color="primary"
								type="text"
								label="Owner ID"
								fullWidth
								name="walletOwnerId"
								// value={walletOwnerId}
								value={walletOwnerId || "Select Owner Id"}
								// onChange={handleChange}
								onChange={(e) => onInputChange(e, "number")}


							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{console.log("GETARRAYowner", getWalletOwnerIdResArray)}
								{getWalletOwnerIdResArray.status !== "failed" && getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Parent ID"
								variant="standard"

								fullWidth={true}
								name="parentId"
								value={parentId}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							{/* <TextField
								size="small"
								color="primary"
								type="text"
								label="Verification Status"
								fullWidth={true}
								name="verificationStatus"
								value={verificationStatus}
								onChange={onInputChange}
							></TextField> */}
							<TextField
								style={{ marginTop: "0rem" }}
								select
								autoFocus
								margin="dense"
								id="name"
								label="Verification Status"
								type="name"
								fullWidth
								variant="standard"
								name="verificationStatus"
								// value={verificationStatus || ""}
								defaultValue={"All" || verificationStatus}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Approve">Approve</MenuItem>
								<MenuItem value="Error">Error</MenuItem>

								<MenuItem value="Failed">Failed</MenuItem>
								<MenuItem value="Pending">Pending</MenuItem>

								<MenuItem value="Reject">Reject</MenuItem>
								<MenuItem value="Review">Review</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Action"
								fullWidth={true}
								name="action"
								defaultValue={"Select Transaction Type" || action}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Transaction Type"
									selected="Select Transaction Type"
								>
									Select Transaction Type
								</MenuItem>
								{(() => {
									if (getTransactionTypeListResArray) {
										return getTransactionTypeListResArray.map((c) => (
											<MenuItem value={c} key={c}>
												{c}
											</MenuItem>
										));
									} else {
										return <MenuItem>No Data</MenuItem>;
									}
								})()}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Role"
								fullWidth={true}
								name="role"
								defaultValue={"Select Role" || role}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Role" selected="Select Role">
									Select Role
								</MenuItem>
								{getRoleListRes.data.roleList &&
									getRoleResArray.map((x) => (
										<MenuItem value={x.role}>{x.role}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getKycReportListReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={getKycReportListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getKycReportListArray.length == undefined ||
					!getKycReportListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}
										className="themeText"

									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Verification ID{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Owner ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Parent ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Entity Type
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Role
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Person ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													First Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Last Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Verification Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Timestamp
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getKycReportListArray &&
												[]
													.concat(getKycReportListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																<span
																	style={{
																		color: "#00b9f5",
																		fontWeight: "bold",
																		textDecoration: "underline",
																		cursor: "pointer"
																	}}
																	onClick={() =>
																		sendVerificationId(
																			row.verificationId,
																			row.customerId
																		)
																	}
																>
																	{row.verificationId}
																</span>
															</TableCell>
															<TableCell align="center">-</TableCell>
															<TableCell align="center">
																{row.customerId}
															</TableCell>

															<TableCell align="center">
																{row.entityType}
															</TableCell>
															<TableCell align="center">
																{row.userRole}
															</TableCell>

															<TableCell align="center">
																{row.personId}
															</TableCell>
															<TableCell align="center">
																{row.firstName}
															</TableCell>

															<TableCell align="center">
																{row.lastName}
															</TableCell>
															<TableCell align="center">{row.action}</TableCell>
															<TableCell align="center">
																{row.verificationStatus}
															</TableCell>
															<TableCell align="center">
																{row.requestTime}
															</TableCell>
															<TableCell align="center">
																{row.verificationStatus == "Pending" && (
																	<>
																		<Tooltip title="Approve">
																			<CustomButton
																				style={{
																					padding: "8px",
																					width: "50px"
																				}}
																				onClick={() =>
																					handleAcceptOrRejectReq(
																						row.verificationId,
																						row.customerId,
																						row.userRole,
																						row.personId,
																						row.fileName,
																						row.action,
																						"Approve"
																					)
																				}
																			>
																				{
																					<ThumbUpAltRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "20px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>

																		<Tooltip title="Reject">
																			<CustomButton
																				style={{
																					padding: "4px",
																					width: "48px",
																					marginLeft: "5px"
																				}}
																				onClick={() =>
																					handleAcceptOrRejectReq(
																						row.verificationId,
																						row.customerId,
																						row.userRole,
																						row.personId,
																						row.fileName,
																						row.action,
																						"Reject"
																					)
																				}
																			>
																				{
																					<ClearRoundedIcon
																						style={{
																							color: "#fff",
																							fontSize: "28px"
																						}}
																					/>
																				}
																			</CustomButton>
																		</Tooltip>
																	</>
																)}

																{row.verificationStatus == "Approve" && (
																	<>
																		<TableCell align="center">
																			<Tooltip title="Approve">
																				<CustomButton
																					style={{
																						padding: "8px",
																						width: "50px"
																					}}
																					disabled={true}
																				// onClick={() =>
																				//   handleAcceptOrRejectReq(
																				//     row.verificationId,
																				//     row.customerId,
																				//     row.userRole,
																				//     row.personId,
																				//     row.fileName,
																				//     row.action,
																				//     "Approve"
																				//   )
																				// }
																				>
																					{
																						<ThumbUpAltRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "20px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>

																			<Tooltip title="Reject">
																				<CustomButton
																					style={{
																						padding: "4px",
																						width: "48px",
																						marginLeft: "5px"
																					}}
																					disabled={true}
																				// onClick={() =>
																				//   handleAcceptOrRejectReq(
																				//     row.verificationId,
																				//     row.customerId,
																				//     row.userRole,
																				//     row.personId,
																				//     row.fileName,
																				//     row.action,
																				//     "Reject"
																				//   )
																				// }
																				>
																					{
																						<ClearRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "28px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>
																		</TableCell>
																	</>
																)}

																{row.verificationStatus == "Reject" && (
																	<>
																		<TableCell align="center">
																			<Tooltip title="Approve">
																				<CustomButton
																					style={{
																						padding: "8px",
																						width: "50px"
																					}}
																					disabled={true}
																				>
																					{
																						<ThumbUpAltRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "20px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>

																			<Tooltip title="Reject">
																				<CustomButton
																					style={{
																						padding: "4px",
																						width: "48px",
																						marginLeft: "5px"
																					}}
																					disabled={true}
																				>
																					{
																						<ClearRoundedIcon
																							style={{
																								color: "#fff",
																								fontSize: "28px"
																							}}
																						/>
																					}
																				</CustomButton>
																			</Tooltip>
																		</TableCell>
																	</>
																)}
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getKycReportListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}

				{/* For pdf data format */}

				{getWalletTransactionListArray.length == undefined ||
					!getWalletTransactionListStatus ? (
					<Card style={{ display: "none" }}></Card>
				) : (
					<div style={{ display: "none" }}>
						<TableContainer component={Paper}>
							<Table className={classes.table} id="walletTransation">
								<TableHead>
									<TableRow>
										<TableCell align="center">Transaction Date </TableCell>
										<TableCell align="center"> Transaction Id</TableCell>
										<TableCell align="center"> Transaction Type</TableCell>

										<TableCell align="center">Transaction Amount</TableCell>
										<TableCell align="center">DSR Contact</TableCell>
										<TableCell align="center">To Customer</TableCell>

										<TableCell align="center">Commission</TableCell>
										<TableCell align="center">Credit</TableCell>
										<TableCell align="center">Debit</TableCell>

										<TableCell align="center">Balance</TableCell>
										<TableCell align="center">Transaction Status</TableCell>
										<TableCell align="center">Remark</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{getWalletTransactionListArray &&
										[]
											.concat(getWalletTransactionListArray)
											.map((row, index) => (
												<TableRow key={index}>
													<TableCell align="center">{row.fromDate}</TableCell>
													<TableCell align="center">
														{row.transactionId}
													</TableCell>
													<TableCell align="center">
														{row.transactionType}
													</TableCell>

													<TableCell align="center">
														{row.transactionAmount}
													</TableCell>
													<TableCell align="center"></TableCell>
													<TableCell align="center">
														{row.toCustomerName}
													</TableCell>

													<TableCell align="center"></TableCell>
													<TableCell align="center">
														{row.creditAmount}
													</TableCell>
													<TableCell align="center">
														{row.debitAmount}
													</TableCell>

													<TableCell align="center">{row.balance}</TableCell>
													<TableCell align="center">
														{row.transactionStatus}
													</TableCell>
													<TableCell align="center">{row.remark}</TableCell>
												</TableRow>
											))}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
				)}
			</Layout>
		</>
	);
}

export default AdminKycReport;
